<template>
  <div id="main">
    <h2
      class="
        page-section-heading
        text-center text-uppercase text-secondary
        mb-0
      "
    >
      Expertise Area
    </h2>
    <!-- Icon Divider-->
    <div class="divider-custom">
      <div class="divider-custom-line"></div>
      <div class="divider-custom-icon"><i class="fas fa-star"></i></div>
      <div class="divider-custom-line"></div>
    </div>
    <div>
    <h1 class="mb-5 mt-5">App Development</h1>
</div>
<div class="container">
    <div class="row">
        <div class="col-md-12">
            <h3 class="progress-title">Flutter</h3>
            <div class="progress">
                <div class="progress-bar" style="width:95%; background:#4286f4;">
                    <div class="progress-value">95%</div>
                </div>
            </div>
            <h3 class="progress-title">Dart</h3>
            <div class="progress">
                <div class="progress-bar" style="width:94%; background:#f2545b;">
                    <div class="progress-value">94%</div>
                </div>
            </div>
            <h3 class="progress-title">Firebase</h3>
            <div class="progress">
                <div class="progress-bar" style="width:90%; background:rgb(255,204,48);">
                    <div class="progress-value">90%</div>
                </div>
            </div>
            <h3 class="progress-title">Google Maps</h3>
            <div class="progress">
                <div class="progress-bar" style="width:92%; background:#32A350;">
                    <div class="progress-value">92%</div>
                </div>
            </div>
            <h3 class="progress-title">Api Intigration</h3>
            <div class="progress">
                <div class="progress-bar" style="width:88%; background:#FFCA28;">
                    <div class="progress-value">88%</div>
                </div>
            </div>
            <h3 class="progress-title">Design</h3>
            <div class="progress">
                <div class="progress-bar" style="width:95%; background:#F57C00;">
                    <div class="progress-value">95%</div>
                </div>
            </div>
            <h3 class="progress-title">Backend API</h3>
            <div class="progress">
                <div class="progress-bar" style="width:98%; background:#FF8A65;">
                    <div class="progress-value">98%</div>
                </div>
            </div>
            
        </div>
    </div>
    
</div>
    <div>
    <h1 class="mb-5 mt-5">Web Development</h1>
</div>
<div class="container">
    <div class="row">
        <div class="col-md-12">
            <h3 class="progress-title">Vue</h3>
            <div class="progress">
                <div class="progress-bar" style="width:95%; background:#3FB27F;">
                    <div class="progress-value">95%</div>
                </div>
            </div>
            <h3 class="progress-title">Django</h3>
            <div class="progress">
                <div class="progress-bar" style="width:90%; background:#0C4B33;">
                    <div class="progress-value">90%</div>
                </div>
            </div>
               <h3 class="progress-title">React.js</h3>
            <div class="progress">
                <div class="progress-bar" style="width:80%; background:#212121;">
                    <div class="progress-value">80%</div>
                </div>
            </div>
         
            <h3 class="progress-title">One Page</h3>
            <div class="progress">
                <div class="progress-bar" style="width:80%; background:rgb(255,204,48);">
                    <div class="progress-value">80%</div>
                </div>
            </div>
            <h3 class="progress-title">Django(DRF)</h3>
            <div class="progress">
                <div class="progress-bar" style="width:88%; background:#A30000;">
                    <div class="progress-value">88%</div>
                </div>
            </div>
            <h3 class="progress-title">Backend API</h3>
            <div class="progress">
                <div class="progress-bar" style="width:98%; background:#FF8A65;">
                    <div class="progress-value">98%</div>
                </div>
            </div>
            
        </div>
    </div>
    
</div>
    
<div>
    <h1 class="mb-5 mt-5">Desktop Application Development</h1>
</div>
<div class="container">
    <div class="row">
        <div class="col-md-12">
            <h3 class="progress-title">C#</h3>
            <div class="progress">
                <div class="progress-bar" style="width:95%; background:#9465CE;">
                    <div class="progress-value">95%</div>
                </div>
            </div>
            <h3 class="progress-title">JAVA</h3>
            <div class="progress">
                <div class="progress-bar" style="width:90%; background:#F0931C;">
                    <div class="progress-value">90%</div>
                </div>
            </div>
            
            
        </div>
    </div>
    
</div>
    
  </div>
</template>
<script>
export default {
    name:"skills"
}
</script>
<style>
#main{
    padding: 0px;
    margin: 0px;
}
</style>